export default function ordreAddInRegroupement(ligneRegroupement) {
  let ordre = ligneRegroupement.ordre;
  if (ligneRegroupement?.lignesCommande?.length > 0) {
    const listeOrdre = ligneRegroupement.lignesCommande.map(ligne => {
      return ligne.ordre;
    });
    ordre = Math.max(...listeOrdre);
  }
  return ordre + 1;
}
